import { render, staticRenderFns } from "./KnowledgeContentManager.vue?vue&type=template&id=0aaf21c6&scoped=true&"
import script from "./KnowledgeContentManager.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentManager.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeContentManager.vue?vue&type=style&index=0&id=0aaf21c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf21c6",
  null
  
)

export default component.exports